import MarkdownIt from 'markdown-it';
import insert from 'markdown-it-ins';

export const mdParser = new MarkdownIt({
    breaks: true,
}).use(insert);